export default __webpack_public_path__ + "static/media/sbo-title-cn.1da8d8f5.webp";